<div class="flex flex-col gap-6 w-full p-4">
    <h2 class="text-xl font-semibold text-center mt-4">{{ translateServ.dictionary['STEP_TAB_TIT_Email'] }}</h2>
    <p class="text-center text-gray-400">{{ translateServ.dictionary['STEP_EMAILS_TEXT'] }}</p>

    <p-toast></p-toast> <!-- Toast component for messages -->

    <div class="card p-card-modern p-datatable-form">
        <p-table [value]="emails" [tableStyle]="{'min-width': '50rem'}">
            <ng-template pTemplate="header">
                <tr>
                    <th style="width: 25%;">{{ translateServ.dictionary['STEP_TAB_TIT_Email'] }}</th>
                    <th style="width: 25%;">{{ translateServ.dictionary['STEP_TAB_TIT_DESC'] }}</th>
                    <th style="width: 15%;">{{ translateServ.dictionary['STEP_TAB_TIT_ACT_STAT'] }}</th>
                    <th style="width: 15%;">{{ translateServ.dictionary['STEP_TAB_TIT_APPROVED'] }}</th>
                    <th style="width: 20%;">{{ translateServ.dictionary['STEP_TAB_TIT_ACT'] }}</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-nameEntry>
                <tr>
                    <td>
                        <!-- This input binds correctly to the name of the current row -->
                        <input
                            pInputText
                            type="text"
                            [(ngModel)]="nameEntry.email"
                            class="w-full"
                            placeholder="Email"
                        />
                    </td>
                    <td>
                        <!-- CORRECTED: This textarea now binds correctly to the description of the current row -->
                        <textarea
                            pInputTextarea
                            [(ngModel)]="nameEntry.description"
                            [rows]="1"
                            [maxlength]="DESCRIPTION_MAX_LENGTH"
                            class="w-full"
                            [placeholder]="translateServ.dictionary['MAINT_IN_TIT_DESC']"
                        ></textarea>
                        <div class="text-right text-xs text-gray-500 mt-1">
                            <!-- CORRECTED: This counter now uses the correct object for the current row -->
                            {{ getRemainingChars(nameEntry.description || '') }} {{ translateServ.dictionary['CHARS_REMAINING'] }}
                        </div>
                    </td>
                    <td>
                        <p-tag
                            [value]="nameEntry.isActive === 1 ? 'Active' : 'Inactive'"
                            (click)="toggleIsActive(nameEntry)"
                            [severity]="nameEntry.isActive === 1 ? 'success' : 'danger'">
                        </p-tag>
                    </td>
                    <td>
                        <p-tag
                            [value]="nameEntry.isApproved === 1 ? 'Approved' : 'Not Approved'"
                            (click)="toggleIsApproved(nameEntry)"
                            [severity]="nameEntry.isApproved === 1 ? 'success' : 'warning'">
                        </p-tag>
                    </td>
                    <td>
                        <div class="flex gap-2">
                            <!-- Delete only in create mode -->
                            <button
                                *ngIf="isCreate"
                                pButton
                                type="button"
                                icon="pi pi-trash"
                                class="p-button-rounded p-button-text p-button-sm p-button-danger"
                                (click)="removeEntry(nameEntry)"
                                [label]="translateServ.dictionary['TOOLTIP_DELETE_ENTRY'] || 'Delete'">
                            </button>

                            <!-- Apply changes only in edit mode -->
                            <button
                                *ngIf="!isCreate"
                                pButton
                                type="button"
                                icon="pi pi-check"
                                class="p-button-rounded p-button-text p-button-sm p-button-info"
                                (click)="applyRowChanges(nameEntry)"
                                [label]="translateServ.dictionary['APPLY_CHANGES'] || 'Apply Changes'">
                            </button>
                        </div>
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="footer" *ngIf="isCreate">
                <tr>
                    <td>
                        <input
                            pInputText
                            type="text"
                            [(ngModel)]="newEntry.email"
                            class="w-full"
                            placeholder="{{ translateServ.dictionary['STEP_EMAILS_HELPER'] }}"
                        />
                    </td>
                    <td>
                        <textarea
                            pInputTextarea
                            [(ngModel)]="newEntry.description"
                            [rows]="1"
                            [maxlength]="DESCRIPTION_MAX_LENGTH"
                            class="w-full"
                            placeholder="{{ translateServ.dictionary['STEP_DESC_HELPER'] }}"
                        ></textarea>
                        <div class="text-right text-xs text-gray-500 mt-1">
                            {{ getRemainingChars(newEntry.description) }} characters remaining
                        </div>
                    </td>
                    <!-- FIX: add Activation Status column -->
                    <td>
                        <p-tag
                            [value]="newEntry.isActive === 1 ? 'Active' : 'Inactive'"
                            (click)="toggleIsActive(newEntry)"
                            [severity]="newEntry.isActive === 1 ? 'success' : 'danger'">
                        </p-tag>
                    </td>
                    <!-- FIX: add Approval Status column -->
                    <td>
                        <p-tag
                            [value]="newEntry.isApproved === 1 ? 'Approved' : 'Not Approved'"
                            (click)="toggleIsApproved(newEntry)"
                            [severity]="newEntry.isApproved === 1 ? 'success' : 'warning'">
                        </p-tag>
                    </td>
                    <td>
                        <p-button
                            [label]="translateServ.dictionary['ADD']"
                            icon="pi pi-plus"
                            severity="success"
                            styleClass="p-button-text p-button-sm"
                            (onClick)="addEntry()">
                        </p-button>
                    </td>
                </tr>
            </ng-template>

            <ng-template pTemplate="emptymessage">
                <tr>
                    <!-- CORRECTED: The colspan must match the number of header columns (5) -->
                    <td [attr.colspan]="5" class="text-center text-gray-500">{{ translateServ.dictionary['STEP_EMAILS_MSG'] }} </td>
                </tr>
            </ng-template>
        </p-table>
    </div>

    <!-- Optional Tab Message (only if not dialog mode) AT BOTTOM -->
	<ng-container *ngIf="!isDialogMode">
		<div class="flex flex-col items-center mb-2 mt-4">
			<div class="p-2 rounded bg-blue-50 text-blue-700 border border-blue-200 w-full text-center">
				{{ translateServ.dictionary['STEP_PROFILERS_OPTIONAL_MSG'] || 'This step is optional. You can skip to the last step if you wish.' }}
			</div>
			<button pButton type="button" class="p-button-text p-button-sm mt-2" (click)="skipToLastStep.emit()">
				{{ translateServ.dictionary['STEP_PROFILERS_SKIP_TO_LAST'] || 'Skip to Last Step' }}
				<i [ngClass]="dirServ.isRtl() ? 'pi pi-backward' : 'pi pi-forward'" class="mr-1"></i>
			</button>
		</div>
	</ng-container>
    
    <!-- Navigation Buttons -->
    <div class="flex justify-between pt-6">
        <ng-container *ngIf="!isDialogMode">
            <p-button
                [label]="translateServ.dictionary['BACK']"
                [icon]="dirServ.isRtl() ? 'pi pi-arrow-right' : 'pi pi-arrow-left'"
                [iconPos]="dirServ.isRtl() ? 'right' : 'left'"
                severity="secondary"
                (onClick)="goToPreviousStep()">
            </p-button>
            <p-button
                [label]="translateServ.dictionary['NEXT']"
                [icon]="dirServ.isRtl() ? 'pi pi-arrow-left' : 'pi pi-arrow-right'"
                [iconPos]="dirServ.isRtl() ? 'left' : 'right'"
                (onClick)="validateAndProceed()">
            </p-button>
        </ng-container>
        <ng-container *ngIf="isDialogMode">
            <p-button
                [label]="translateServ.dictionary['CANCEL'] || 'Cancel'"
                [icon]="'pi pi-times'"
                severity="secondary"
                (onClick)="closeDialog()">
            </p-button>
            <p-button
                [label]="translateServ.dictionary['SAVE'] || 'Save'"
                [icon]="'pi pi-save'"
                (onClick)="saveAndSubmit()"
                [disabled]="emails.length === 0">
            </p-button>
        </ng-container>
    </div>
</div>
